export default {
  form: {
    first_name: {
      label: 'Nome',
    },
    last_name: {
      label: 'Cognome',
    },
    email: {
      label: 'Email',
    },
    phone_number: {
      label: 'Numero di telefono',
    },
    birthday: {
      label: 'Data di nascita',
    },
    city: {
      label: 'Città',
    },
  },
  buttons: {
    save: 'Salva',
  },
  toasts: {
    success: 'Profilo aggiornato con successo',
    error: 'Aggiornamento profilo fallito',
  },
};
